import { render, staticRenderFns } from "./StudyRecord.vue?vue&type=template&id=24fb6a78&"
import script from "./StudyRecord.vue?vue&type=script&lang=ts&"
export * from "./StudyRecord.vue?vue&type=script&lang=ts&"
import style0 from "./StudyRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports